import Logger from "js-logger";
// import sprintf from "sprintf-js";
import LoggingSource from "../LoggingSource";

import { v1 as uuidv1 } from "uuid";

const uuid = uuidv1();

const LOGGING_SEPARATOR = " | ";

const consoleLoggingHandler = Logger.createDefaultHandler({
  formatter: function (messages, context) {
    for (let i = 0; i < messages.length; i++) {
      if (typeof messages[i] == "object")
        messages[i] = JSON.stringify(messages[i]);
    }

    // const args = messages.splice(1);
    // messages[0] = sprintf.vsprintf(messages[0], args);

    messages.unshift(LOGGING_SEPARATOR);
    messages.unshift(context.level.name);
    messages.unshift(LOGGING_SEPARATOR);
    messages.unshift(uuid);
    messages.unshift(LOGGING_SEPARATOR);
    messages.unshift(context.name);
    messages.unshift(LOGGING_SEPARATOR);
    messages.unshift(new Date().toUTCString());
  },
});

Logger.useDefaults();
Logger.setHandler(consoleLoggingHandler);
Logger.setLevel(Logger.DEBUG);

Logger.get(LoggingSource.UIDonor);
Logger.get(LoggingSource.UIDonorPayment);
Logger.get(LoggingSource.UIFundingArea);
Logger.get(LoggingSource.UIFundingRequest);
Logger.get(LoggingSource.UINewSchoolRegistration);
Logger.get(LoggingSource.UIPrincipalRegistration);
Logger.get(LoggingSource.UISchoolOfficer);
Logger.get(LoggingSource.UISchool);
Logger.get(LoggingSource.UIUser);
Logger.get(LoggingSource.UIReferenceData);
Logger.get(LoggingSource.UIDonorDonationDetails);
Logger.get(LoggingSource.IPInfo);
Logger.get(LoggingSource.UISec);
Logger.get(LoggingSource.UISystemSetting);
Logger.get(LoggingSource.UIConfig).info(
  `Welcome... Logging is enabled - level ${
    Logger.getLevel().name
  }... initialising VueJS for the ${import.meta.env.VITE_NODE_ENV} environment.`
);

export default Logger;
